<template>
  <div class="account container-custom">
    <div v-if="this.$store.state.token">
      <div class="account__title">
        Account Statement
      </div>
      <div v-if="isLoading">
        <loading />
      </div>
      <div v-show="!isLoading">
        <div class="account__filters">
          <div class="dropdown account__filters__wager">
            <button
                class="btn btn-secondary account__filters__wager__dropdown"
                type="button" id="dropdownMenuButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            >
              {{ wagerStatus.title }}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a
                  v-for="(item, index) in dataDropdownStatus"
                  :key="index"
                  @click="changeFilterDropdown(index)"
                  class="dropdown-item"
                  :class="{ active: item.active }"
              >{{ item.title }}</a>
            </div>
          </div>
          <div class="dropdown account__filters__wager">
            <button
                class="btn btn-secondary account__filters__wager__dropdown"
                type="button" id="dropdownFilterDate"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            >
              {{ dateRange.title }}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownFilterDate">
              <a
                  v-for="(item, index) in dataDropdownDate"
                  :key="index"
                  @click="changeFilterDropdownDate(index)"
                  class="dropdown-item"
                  :class="{ active: item.active }"
              >{{ item.title }}</a>
            </div>
          </div>
        </div>
        <div class="account__content">
          <div class="account__content__fields">
            <div class="account__content__field__id content-field-common">
              ID
            </div>
            <div class="account__content__field__date content-field-common">
              Date
            </div>
            <div class="account__content__field__descriptions content-field-common">
              Description
            </div>
            <div class="account__content__field__status content-field-common">
              Status
            </div>
            <div class="account__content__field__total-amount content-field-common">
              Total Bet Amount
            </div>
            <div class="account__content__field__total-return content-field-common">
              Total Return
            </div>
            <div class="account__content__field__details content-field-common"></div>
          </div>
          <div
              v-for="(item, index) in listWagers"
              :key="index"
              class="account__content__item"
              :class="{itemActive: item.isActiveDetail}"
          >
            <div class="account__content__item__main">
              <div class="account__content__item__id content-field-common">
                {{ item.betslipId }}
              </div>
              <div class="account__content__item__date content-field-common">
                {{ $filters.formatDate(item.createdAt) }}
              </div>
              <div class="account__content__item__des content-field-common">
                {{ item.description || '' }}
              </div>
              <div class="account__content__item__status content-field-common">
                {{ item.status || ''}}
              </div>
              <div class="account__content__item__total-amount content-field-common">
                {{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.paid || 0) }}
              </div>
              <div class="account__content__item__total-return content-field-common">
                {{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.winnings || 0) }}
              </div>
              <div class="account__content__item__details content-field-common">
                <a @click="clickWagerDetail(item.reference, index)">Details {{ item.isActiveDetail ? '-' : '+'}}</a>
              </div>
            </div>
            <div v-if="isLoadingDetail && item.isActiveDetail">
              <loading />
            </div>
            <div v-show="!isLoadingDetail">
              <div v-if="item.isActiveDetail" class="account__content__item__more-details">
                <div v-for="(detail, k) in wagerDetail"
                     :key="k">
                  <div
                      v-for="(valueDetail, keyDetail) in detail"
                      :key="keyDetail"
                  >
                    <div class="account__content__item__more-details__content">
                      <div class="account__content__item__more-details__title">
                        {{ valueDetail.name }}
                      </div>
                      <div class="account__content__item__more-details__draw-date">
                        Draw Date: {{ $filters.formatDate(valueDetail.drawDate) }}
                      </div>
                      <div class="account__content__item__more-details__draw-id">
                        Draw ID: {{ valueDetail.drawId }}
                      </div>
                      <div class="account__content__item__more-details__results">
                        <label>Results:</label>
                        <div class="account__content__item__more-details__results__numbers">
                          <div
                              v-for="(item, index) in valueDetail.results && valueDetail.results[0]"
                              :key="index"
                              class="account__content__item__more-details__results-number">
                            <a>{{ item }}</a>
                          </div>
                          <div
                              v-for="(item, index) in valueDetail.results && valueDetail.results[1]"
                              :key="index"
                              class="account__content__item__more-details__results-number bonus-ball">
                            <a>{{ item }}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="more-details__fields">
                      <div class="more-details__field__id field-common">
                        Bet ID
                      </div>
                      <div class="more-details__field__your-bet field-common">
                        Your Bet
                      </div>
                      <div class="more-details__field__wager-type field-common">
                        Wager Type
                      </div>
                      <div class="more-details__field__odds field-common">
                        Odds
                      </div>
                      <div class="more-details__field__bet-amount field-common">
                        Bet Amount
                      </div>
                      <div class="more-details__field__potential-return field-common">
                        Potential Return
                      </div>
                      <div class="more-details__field__winnings-tax field-common">
                        Winnings Tax
                      </div>
                      <div class="more-details__field__total-potential field-common">
                        Total Potential Return
                      </div>
                      <div class="more-details__field__actual-return field-common">
                        Actual Return
                      </div>
                      <div class="more-details__field__status field-common">
                        Status
                      </div>
                    </div>
                    <div
                        v-for="(item, index) in valueDetail.bets"
                        :key="index"
                        class="more-details__data-items"
                    >
                      <div class="more-details__data-items__id data-item-common">
                        {{ item.betId }}
                      </div>
                      <div
                          v-if="item.numbers.length > 0"
                          class="more-details__data-items__your-bet data-item-common"
                      >
                        <b>{{ item.summary }}</b> <br> {{ item.text }}
                        <div class="more-details__data-items__your-bet__numbers">
                          <div
                              v-for="(item, index) in item.numbers[0]"
                              :key="index"
                              class="details__results-number">
                            <a>{{ item }}</a>
                          </div>
                          <div
                              v-for="(item, index) in item.numbers[1]"
                              :key="index"
                              class="details__results-number bonus-ball">
                            <a>{{ item }}</a>
                          </div>
                        </div>
                      </div>
                      <div
                          v-if="item.numbers.length === 0"
                          class="more-details__data-items__your-bet data-item-common"
                      >
                        {{ item.summary }}: {{ item.text }}
                      </div>
                      <div class="more-details__data-items__wager-type data-item-common">
                        {{ item.betType }}
                      </div>
                      <div class="more-details__data-items__odds data-item-common">
                        {{ $filters.formatThousandNumber(item.odds) }}
                      </div>
                      <div class="more-details__data-items__bet-amount data-item-common">
                        {{ this.wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.stake) }}
                      </div>
                      <div class="more-details__data-items__potential-return data-item-common">
                        {{ this.wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.stake * item.odds) }}
                      </div>
                      <div class="more-details__data-items__winnings-tax data-item-common">
                        {{ this.wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.tax) }}
                      </div>
                      <div class="more-details__data-items__total-potential data-item-common">
                        {{ this.wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber((item.stake * item.odds) - item.tax)}}
                      </div>
                      <div class="more-details__data-items__actual-return data-item-common">
                        {{ this.wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.winnings) }}
                      </div>
                      <div class="more-details__data-items__field__status data-item-common">
                        {{ item.status }}
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="account__content__mobile">
          <div
              v-for="(item, index) in listWagers"
              :key="index"
              class="account__content__mobile__content"
          >
            <div class="account__content__mobile__item">
              <div class="account__content__mobile__item__title">ID</div>
              <div class="account__content__mobile__item__content">{{ item.betslipId }}</div>
            </div>
            <div class="account__content__mobile__item">
              <div class="account__content__mobile__item__title">Date</div>
              <div class="account__content__mobile__item__content">{{ $filters.formatDate(item.createdAt) }}</div>
            </div>
            <div class="account__content__mobile__item">
              <div class="account__content__mobile__item__title">Description</div>
              <div class="account__content__mobile__item__content">{{ item.description }}</div>
            </div>
            <div class="account__content__mobile__item">
              <div class="account__content__mobile__item__title">Status</div>
              <div class="account__content__mobile__item__content">{{ item.status }}</div>
            </div>
            <div class="account__content__mobile__item">
              <div class="account__content__mobile__item__title">Total Bet Amount</div>
              <div class="account__content__mobile__item__content">{{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.paid) }}</div>
            </div>
            <div class="account__content__mobile__item">
              <div class="account__content__mobile__item__title">Total Return</div>
              <div class="account__content__mobile__item__content">{{ wagerDetailTransaction.currencySymbol }} {{ $filters.formatThousandNumber(item.winnings) }}</div>
            </div>
            <div class="account__content__mobile__buttons">
              <button
                  @click="clickWagerDetail(item.reference, index, 'mobile')"
                  class="btn btn-info account__content__mobile__buttons__details"
              >DETAILS</button>
            </div>
          </div>
        </div>
        <div class="account__pagination">
          <div
              v-if="pages > 1 && page > 1"
              @click="handlePaginationBack()"
              class="account__pagination__back active-pagination"
          >
            Back
          </div>
          <div v-else class="account__pagination__back btn-disabled">
            Back
          </div>
          <div v-if="pages < 2" class="account__pagination__info">
            Page {{ page }}
          </div>
          <div v-if="pages > 1" class="account__pagination__info">
            Page {{ page }} of {{ pages }}
          </div>
          <div
              v-if="pages > 1 && page < pages"
              @click="handlePaginationNext()"
              class="account__pagination__next active-pagination"
          >
            Next
          </div>
          <div v-else class="account__pagination__next btn-disabled">
            Next
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="account__title">
        Account Statement
      </div>
      <div class="account__login">
        Please <router-link :to="'/login'">LOGIN</router-link> to view your wagers.
      </div>
    </div>
    <ModalCommon
        v-if="isShowModalDetail"
        @close="isShowModalDetail = false"
    >
      <WagerDetailMobile
          :wager-detail="wagerDetail"
          :wager-detail-transaction="wagerDetailTransaction"
      />
    </ModalCommon>
  </div>
</template>
<script>
import WagerService from '@/services/wager.service';
import ModalCommon from '@/components/common/modal/modal-common.vue';
import WagerDetailMobile from "./WagerDetailMobile";
import Loading from '@/components/common/loading/Loading.vue'
export default {
  props: {
  },
  components: {
    WagerDetailMobile,
    ModalCommon,
    Loading
  },
  data () {
    return {
      isLoading: false,
      isLoadingDetail: false,
      isShowModalDetail: false,
      filterDate: '',
      wagers: [],
      page: 1,
      pages: 0,
      wagerStatus: {
        value: 'all',
        title: 'All'
      },
      dateRange: {
        value: 'all',
        title: 'All'
      },
      dataDropdownStatus: [
        {
          value: 'all',
          title: 'All',
          active: false
        },
        {
          value: 'open',
          title: 'Open',
          active: false
        },
        {
          value: 'settled',
          title: 'Settled',
          active: false
        }
      ],
      dataDropdownDate: [
        {
          value: 'all',
          title: 'All',
          active: false
        },
        {
          value: 'last-1-day',
          title: 'Last one day',
          active: false
        },
        {
          value: 'last-2-days',
          title: 'Last two days',
          active: false
        },
        {
          value: 'last-3-days',
          title: 'Last three days',
          active: false
        },
        {
          value: 'last-7-days',
          title: 'Last seven days',
          active: false
        },
        {
          value: 'last-two-weeks',
          title: 'Last two weeks',
          active: false
        }
      ],
      wagerDetail: [],
      wagerDetailTransaction: {},
    }
  },
  computed: {
    token() {
     return this.$store.getters.getToken
    },
    listWagers() {
      return this.wagers
    },
    partnerCode() {
      return process.env.VUE_APP_PARTNER_CODE;
    },
    customerID() {
      return process.env.VUE_APP_CUSTOMER_ID;
    }
  },
  // created() {
  //   this.$store.dispatch('apiGetCustomerToken', {customerID: this.customerID, partnerCode: this.partnerCode})
  // },
  mounted() {
    if(this.token) {
      this.getWagers(this.page, this.wagerStatus.value, this.dateRange.value, this.token)
    }
  },
  watch: {
    token() {
      this.getWagers(this.page, this.wagerStatus.value, this.dateRange.value, this.token)
    },
  },
  methods: {
    changeFilterDropdown(index) {
      this.dataDropdownStatus.forEach((value, i) => {
        value.active = i === index ? !value.active : false
      })
      if (index === 0) {
        this.wagerStatus = { value: 'all', title: 'All' }
      }
      if (index === 1) {
        this.wagerStatus = { value: 'open', title: 'Open' }
      }
      if (index === 2) {
        this.wagerStatus = { value: 'settled', title: 'Settled' }
      }
      this.getWagers(this.page, this.wagerStatus.value, this.dateRange.value, this.token)
    },
    changeFilterDropdownDate(index) {
      this.dataDropdownDate.forEach((value, i) => {
        value.active = i === index ? !value.active : false
      })
      if (index === 0) {
        this.dateRange = { value: 'all', title: 'All' }
      }
      if (index === 1) {
        this.dateRange = { value: 'last-1-day', title: 'Last one day' }
      }
      if (index === 2) {
        this.dateRange = { value: 'last-2-days', title: 'Last two days' }
      }
      if (index === 3) {
        this.dateRange = { value: 'last-3-days', title: 'Last three days' }
      }
      if (index === 4) {
        this.dateRange = { value: 'last-7-days', title: 'Last seven days' }
      }
      if (index === 5) {
        this.dateRange = { value: 'last-two-weeks', title: 'Last two weeks' }
      }
      this.getWagers(this.page, this.wagerStatus.value, this.dateRange.value, this.token)
    },
    getWagers(page, wagerStatus, date, token) {
      this.isLoading = true;
      WagerService.apiGetWagers(page, wagerStatus, date, token).then((res) => {
        this.isLoading = false;
        this.wagers = res.results.map((item, i) => {
          if(i === 0) {
            this.isLoadingDetail = true;
            WagerService.apiGetWagerDetails(this.token, item.reference).then((res) => {
              this.isLoadingDetail = false;
              this.wagerDetail = res.games;
              this.wagerDetailTransaction = res.transaction;
            });
            return { ...item, isActiveDetail: true }
          } else {
            return { ...item, isActiveDetail: false }
          }
        });
        this.pages = res.pages;
      });
    },
    handlePaginationBack() {
      this.page = this.page-1
      this.getWagers(this.page, 'all', 'all', this.token)
    },
    handlePaginationNext() {
      this.page = this.page+1
      this.getWagers(this.page, 'all', 'all', this.token)
    },
    clickWagerDetail(reference, index, type) {
      if(type === 'mobile') {
        this.isShowModalDetail= true;
      }
      this.isLoadingDetail = true;
      WagerService.apiGetWagerDetails(this.token, reference).then((res) => {
        this.isLoadingDetail = false;
        this.wagerDetail = res.games;
        this.wagerDetailTransaction = res.transaction;
      });
      this.listWagers.forEach((item, i) => {
        if (i === index) {
          item.isActiveDetail = !item.isActiveDetail;
        } else {
          item.isActiveDetail =false
        }
      })
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/wager/wager.scss"/>
